export default "__VITE_ASSET__CqU9CQSI__"